import type { NotificationData } from '@sb/feathers-types';

import { getNotificationsService } from './utils';

export async function createNotification(
  notification: Omit<NotificationData, 'id' | 'createdAt' | 'statusByUserID'>,
): Promise<void> {
  await getNotificationsService().create(notification);
}
